import { createQueryKey } from '../../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../../query/types';

const consumerCampaignKeys = <T extends QueryKey>(keys: T) => {
  const key = [...keys, 'campaigns'] as const;

  return createQueryKey({
    all: key,
    id: (campaignId: QueryKeyParam) =>
      createQueryKey({
        all: [...key, campaignId] as const,
        detail: [...key, campaignId, 'detail'] as const,
      }),
  });
};

export { consumerCampaignKeys };
